module.exports = __webpack_public_path__ + "static/media/cheerleading.e2305775.mp4";